<ub-pagination [pagesCount]="pagesCount | async" [currentPage]="currentPage | async" (pageSelected)="onPageSelected($event)"></ub-pagination>